export default "/credits/business/assets/e35089b06414b59b211badcad1851827.png";